import SkeletonRoutineItem from './SkeletonRoutineItem';
import SkeletonBlock from './SkeletonBlock';

const OPTION_CHIP_COUNT = 3;
const HABIT_ROW_COUNT = 2;

interface SkeletonCustomRoutineItemProps {
  className?: string;
}

const SkeletonCustomRoutineItem = ({
  className = ''
}: SkeletonCustomRoutineItemProps) => (
  <li
    className={`w-full flex items-start ~gap-2/3 ${className}`}
    data-testid='skeleton-custom-routine-item'>
    <SkeletonBlock className='~w-5/6 ~h-5/6 flex-shrink-0 ~mt-1/3' />
    <div className='flex-1 flex flex-col ~gap-3/4 rounded-lg border border-secondary-400/60 ~p-2/4 bg-primary-50 dark:bg-secondary-dark-200'>
      <SkeletonBlock className='~h-5/6 ~w-36/48 border-0' />
      <div className='w-full flex flex-col ~gap-2/3 ~p-2/4'>
        <div className='w-full flex flex-col ~gap-1/1.5'>
          <SkeletonBlock className='~h-3/4 ~w-12/16 border-0' />
          <SkeletonBlock className='~h-10/12 w-full' />
        </div>
        <div className='w-full flex items-center ~gap-2/3 flex-wrap'>
          {Array.from({ length: OPTION_CHIP_COUNT }).map((_, index) => (
            <SkeletonBlock key={index} className='~h-9/11 ~w-28/36' />
          ))}
        </div>
        <div className='w-full flex flex-col ~gap-2/3 ~mt-2/3'>
          {Array.from({ length: HABIT_ROW_COUNT }).map((_, index) => (
            <SkeletonRoutineItem key={index} />
          ))}
        </div>
      </div>
    </div>
  </li>
);

export default SkeletonCustomRoutineItem;
